import type { PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import NotFound from '@components/NotFound';

import { isProduction } from '@constants/env';

import { useCuration } from '@hooks/useCuration';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useSession } from '@hooks/useSession';

import { TrackerType } from '@models/vital-sign';

import FormDrilldown from '@views/Records/VitalSigns/FormDrilldown';

export default function AddBodyRecordPage({ params }: PageProps) {
  const { startAddingRecord, stopCurating } = useCuration();
  const { flags } = useFeatureFlags();
  const {
    state: { isCurator, isPractitioner },
  } = useSession();
  useEffect(() => {
    startAddingRecord();
    return () => stopCurating();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canAdd =
    flags.isBodyUpdateObservationEnabled ||
    (!isProduction && (isCurator || isPractitioner));

  return (
    <>
      {canAdd ? (
        <FormDrilldown {...params} type={TrackerType.Body} />
      ) : (
        <NotFound />
      )}
    </>
  );
}
